import React from 'react';
import { Route } from 'react-router';
import { getUserData } from './helpers/Common';
import { isLoggedIn, hasGlobalRoute, getGlobalRoute } from './helpers/User';
import { routeAfterLogin, rootDomainUrl } from './config/Config';
import Login from './auth/Login';
import Home from './Home';

import Main from './layouts/Main';
import Register from './auth/Register';
import BirthdayWish from './pages/BirthdayWish';
import CorporateLogin from './auth/CorporateLogin';
import TcsLogin from './auth/TcsLogin';
import ChatRate from './pages/ChatRate';
import TeleCall from './pages/TeleCall';
import TeleCallFeedback from './pages/TeleCallFeedback';
import Feathers from './pages/Feathers';
import PinExpired from './pages/PinExpired';
import WaitForLogin from './pages/WaitForLogin';
import ContractCancelled from './pages/ContractCancelled';
import PinDeactivated from './pages/PinDeactivated';
import LoginAddObserver from './pages/LoginAddObserver';
import ScheduleDlr from './pages/ScheduleDlr';
import Feedback from './personal_interactions/iseek/Feedback';
import Evaluator from './lr_dlr_components/Evaluator';
import DigitalEvaluation from './lr_dlr_components/DigitalEvaluation';
import PracticeResponse from './practice/PracticeResponse';
import Mchat from './mchat/Mchat';
import Chat from './chat/Chat';
import RoomCompLayout from './layouts/RoomCompLayout';
import PersonalInteractionsLayout from './layouts/PersonalInteractionsLayout';
import LearningRecordsLayout from './layouts/LearningRecordsLayout';
import PracticeLayout from './layouts/PracticeLayout';
import RightMenuLayout from './layouts/RightMenuLayout';
import LearningResourcesLayout from './layouts/LearningResourcesLayout';
import GroupInteractionsLayout from './layouts/GroupInteractionsLayout';
import XrecapLayout from './layouts/XrecapLayout';
import DmWallLayout from './layouts/DmWallLayout';

// All checks goes here
const requireAuthAndGlobalRoute = (nextState, replace) => {
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (!hasGlobalRoute()) {
        replace({
            pathname: getGlobalRoute()
        })
    }
}
const requireGlobalRoute = (nextState, replace) => {
    if (isLoggedIn()) {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const userEntryAuth = (nextState, replace) => {
    if (isLoggedIn() && !hasGlobalRoute()) {
        replace({
            pathname: getGlobalRoute()
        })
    }
    if (isLoggedIn() && hasGlobalRoute()) {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const birthdayAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "birthdayNotify") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const chatRateAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "chatRating") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const teleCallAuth = (nextState, replace) => {
    const beforeRoutes = getUserData("beforeRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (beforeRoutes.length <= 0 || beforeRoutes[0].identifier !== "teleCall") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const teleCallFeedbackAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "teleCallFeedback") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const feathersAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "feathers") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const pinExpiredAuth = (nextState, replace) => {
    const beforeRoutes = getUserData("beforeRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (beforeRoutes.length <= 0 || beforeRoutes[0].identifier !== "pinExpired") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const waitForLoginAuth = (nextState, replace) => {
    const beforeRoutes = getUserData("beforeRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (beforeRoutes.length <= 0 || beforeRoutes[0].identifier !== "waitForLogin") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const contractCancelledAuth = (nextState, replace) => {
    const beforeRoutes = getUserData("beforeRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (beforeRoutes.length <= 0 || beforeRoutes[0].identifier !== "contractCancelled") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const pinDeactivatedAuth = (nextState, replace) => {
    const beforeRoutes = getUserData("beforeRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (beforeRoutes.length <= 0 || beforeRoutes[0].identifier !== "pinDeactivated") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const LoginAddObserverAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "addObserver") {
        replace({
            pathname: routeAfterLogin
        })
    }
}
const ScheduleDlrAuth = (nextState, replace) => {
    const afterRoutes = getUserData("afterRoutes", true);
    if (!isLoggedIn()) {
        window.location = window.location.origin
    } else if (afterRoutes.length <= 0 || afterRoutes[0].identifier !== "scheduleDlr") {
        replace({
            pathname: routeAfterLogin
        })
    }
}


const customLogincheck=(nextState, replace) => {
    if (!isLoggedIn()) {
        window.location = rootDomainUrl
    }
    else
    {
        replace({
            pathname: routeAfterLogin
        }) 
    }
}
const routes = (<Route>
    // Website home route
    <Route path="/" component={Home} onEnter={requireGlobalRoute} />
    <Route path="/login_user/:username/:password" component={Login} onEnter={userEntryAuth} />

    // User authentication routes
    <Route path="/login" component={Login} onEnter={customLogincheck} />
    <Route path="/register" component={Register} onEnter={userEntryAuth} />

    // Basic routes after login
    <Route path="/user/birthday" component={BirthdayWish} onEnter={birthdayAuth} />
    <Route path="/user/ecoach/rating" component={ChatRate} onEnter={chatRateAuth} />
    <Route path="/user/telecall/schedule" component={TeleCall} onEnter={teleCallAuth} />
    <Route path="/user/telecall/feedback" component={TeleCallFeedback} onEnter={teleCallFeedbackAuth} />
    <Route path="/user/observer/feathers" component={Feathers} onEnter={feathersAuth} />
    <Route path="/user/pinexpired" component={PinExpired} onEnter={pinExpiredAuth} />
    <Route path="/user/wait-for-login" component={WaitForLogin} onEnter={waitForLoginAuth} />
    <Route path="/user/contract-cancelled" component={ContractCancelled} onEnter={contractCancelledAuth} />
    <Route path="/user/pin-deactivated" component={PinDeactivated} onEnter={pinDeactivatedAuth} />
    <Route path="/user/observer/add" component={LoginAddObserver} onEnter={LoginAddObserverAuth} />
    <Route path="/user/schedule/dlr" component={ScheduleDlr} onEnter={ScheduleDlrAuth} />
    <Route path="/corporate-login/:accessCode" component={CorporateLogin} />
    <Route path="/tcs-login/:accessCode" component={TcsLogin} />

    <Route path="/learningroom" component={Main} onEnter={requireAuthAndGlobalRoute} />
    <Route path="/feedback/:ass_id/:poll_id/:lr_id/:domain" component={Feedback} />
    <Route path="/evaluator/:asse_id/:lear_id" component={Evaluator} />
    <Route path="/digital-evaluation/:det" component={DigitalEvaluation} />
    <Route path="/buddychat" component={Mchat} onEnter={requireAuthAndGlobalRoute}/>
    <Route path="/chat/:ec_id/:time_slot_id" component={Chat} />
    <Route path="/practice_response/:score_id" component={PracticeResponse} />

    <Route path="/mobileapp-learning-room/:app_code/:device_id/:room_id/:dlr_id/:compseq_id/:divider_id" component={RoomCompLayout} />
    <Route path="/personal-interaction/:app_code/:device_id/:type" component={PersonalInteractionsLayout} />
    <Route path="/learning-records/:app_code/:device_id/:type" component={LearningRecordsLayout} />
    <Route path="/practice/:app_code/:device_id/:type" component={PracticeLayout} />
    <Route path="/qlinks/:app_code/:device_id/:type" component={RightMenuLayout} />
    <Route path="/learning-resources/:app_code/:device_id/:type" component={LearningResourcesLayout} />
    <Route path="/group-interactions/:app_code/:device_id/:type" component={GroupInteractionsLayout} />
    <Route path="/xrecap/:app_code/:device_id/:type" component={XrecapLayout} />
    <Route path="/dmwall/:app_code/:device_id" component={DmWallLayout} />
</Route>)

export default routes



// WEBPACK FOOTER //
// ./src/routes.js